import { create } from 'zustand'

export interface IncomingCall {
  roomId: string
  callerId: string
  callType: 'voice' | 'video'
}

export interface GroupCall {
  roomId: string
  callType: 'voice' | 'video'
  title: string
}

interface CallState {
  incoming: IncomingCall | null
  setIncoming: (call: IncomingCall | null) => void
  groupCall: GroupCall | null
  setGroupCall: (call: GroupCall | null) => void
}

export const useCallStore = create<CallState>()((set) => ({
  incoming: null,
  setIncoming: (incoming) => set({ incoming }),
  groupCall: null,
  setGroupCall: (groupCall) => set({ groupCall }),
}))
